import { 
    ADD_EXTRA_ADMIN,
    UPDATE_EXTRA_ADMIN,
    DELETE_EXTRA_ADMIN,
    GET_EXTRA_ADMIN,
    GET_ALL_EXTRA_ADMIN
} from '../actions/ExtraAdmin.action';

const initialState = {
    addExtraAdmin: '',
    updateExtraAdmin: '',
    deleteExtraAdmin: '',
    getExtraAdmin: '',
    getAllExtraAdmin: ''
}

const ExtraAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_EXTRA_ADMIN:
            return { ...state, addExtraAdmin: action.payload }
        case UPDATE_EXTRA_ADMIN:
            return { ...state, updateExtraAdmin: action.payload }
        case DELETE_EXTRA_ADMIN:
            return { ...state, deleteExtraAdmin: action.payload }
        case GET_EXTRA_ADMIN:
            return { ...state, getExtraAdmin: action.payload }
        case GET_ALL_EXTRA_ADMIN:
            return { ...state, getAllExtraAdmin: action.payload }
        default:
            return state
    }
}

export default ExtraAdminReducer;